import { render } from "./Step1.vue?vue&type=template&id=5c53285e"
import script from "./Step1.vue?vue&type=script&lang=ts"
export * from "./Step1.vue?vue&type=script&lang=ts"
script.render = render

export default script